function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.464 2a1 1 0 10-2 0v2H3.867A2.867 2.867 0 001 6.867v16.266A2.867 2.867 0 003.867 26h10.985c-.185-.64-.3-1.31-.338-2H3.867A.867.867 0 013 23.133V10h22v4.624a8.939 8.939 0 012 .582v-8.34A2.867 2.867 0 0024.133 4h-2.602V2a1 1 0 10-2 0v2H8.464V2zm15.67 4c.478 0 .866.388.866.867V8H3V6.867C3 6.388 3.388 6 3.867 6h20.266z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.575 22.333a8.945 8.945 0 01.49-1.977v-.59H12.93v2.567h1.644zM16.13 18.332a9.053 9.053 0 012.134-2.153v-.262H16.13v2.415zM8.664 12.067H6.531v2.566h2.133v-2.566zM8.664 15.917H6.531v2.566h2.133v-2.566zM15.065 12.067H12.93v2.566h2.134v-2.566zM15.065 15.917H12.93v2.566h2.134v-2.566zM11.864 12.067H9.731v2.566h2.133v-2.566zM11.864 15.917H9.731v2.566h2.133v-2.566zM18.265 12.067H16.13v2.566h2.134v-2.566zM21.464 12.067H19.33v2.566h2.133v-2.566zM8.664 19.767H6.531v2.566h2.133v-2.566zM11.864 19.767H9.731v2.566h2.133v-2.566zM23.995 23.003h3.64v.994h-3.64v3.64h-.993v-3.64h-3.64v-.994h3.64v-3.64h.993v3.64z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 23.5a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm7.5-6.04a6.04 6.04 0 100 12.08 6.04 6.04 0 000-12.08z",
  fill: "currentColor"
})));